<template>
  <div
    :class="['email-component', 'divider-component', { selected }]"
    @click="handleClick"
    :style="containerStyles"
  >
    <hr :style="dividerStyles" />
  </div>
</template>

<script>
export default {
  name: 'DividerComponent',
  props: ['componentData', 'selected'],
  computed: {
    containerStyles() {
      const styles = this.componentData.styles || {}
      return {
        marginTop: `${styles.marginTop || '20'}px`,
        marginBottom: `${styles.marginBottom || '20'}px`,
        padding: '0',
        cursor: 'pointer'
      }
    },

    dividerStyles() {
      const styles = this.componentData.styles || {}

      return {
        border: 'none',
        borderTop: `${styles.thickness || '1'}px solid ${styles.lineColor || '#e5e7eb'}`,
        margin: '0',
        width: '100%'
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.divider-component {
  position: relative;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  border-radius: 4px;
}

.divider-component:hover {
  border-color: rgba(225, 78, 202, 0.3);
  background: rgba(225, 78, 202, 0.05);
}

.divider-component.selected {
  border-color: #e14eca;
  box-shadow: 0 0 0 4px rgba(225, 78, 202, 0.1);
  background: rgba(225, 78, 202, 0.05);
}

.divider-component hr {
  display: block;
  height: 0;
  box-sizing: content-box;
}
</style>
